<template>
  <div
    v-if="isModal"
    cy="base-modal"
    class="base-modal z99 flex-center wh100 fixed left0 top0"
  >
    <div class="relative">
      <i class="close-icon absolute pointer"
         @click="Close_Modal">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="19.8" cy="19.7998" r="14" fill="white"/>
          <path d="M29.6985 29.6985C24.2396 35.1574 15.3584 35.1574 9.89949 29.6985C4.44063 24.2396 4.44063 15.3584 9.89949 9.89952C15.3584 4.44065 24.2396 4.44065 29.6985 9.89952C35.1573 15.3584 35.1573 24.2396 29.6985 29.6985ZM11.3137 11.3137C6.63266 15.9948 6.63266 23.6032 11.3137 28.2843C15.9948 32.9653 23.6032 32.9653 28.2843 28.2843C32.9653 23.6032 32.9653 15.9948 28.2843 11.3137C23.6032 6.63268 15.9948 6.63268 11.3137 11.3137Z" fill="#747474"/>
          <path d="M24.7487 24.7488C24.3528 25.1448 23.7305 25.1448 23.3345 24.7488L14.8492 16.2635C14.4533 15.8675 14.4533 15.2453 14.8492 14.8493C15.2452 14.4533 15.8675 14.4533 16.2635 14.8493L24.7487 23.3346C25.1447 23.7306 25.1447 24.3528 24.7487 24.7488Z" fill="#747474"/>
          <path d="M24.7487 16.2635L16.2635 24.7487C15.8675 25.1447 15.2452 25.1447 14.8492 24.7487C14.4533 24.3528 14.4533 23.7305 14.8492 23.3345L23.3345 14.8492C23.7305 14.4533 24.3528 14.4533 24.7487 14.8492C25.1447 15.2452 25.1447 15.8675 24.7487 16.2635Z" fill="#747474"/>
        </svg>
      </i>

      <slot />
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, onUpdated } from 'vue';

  const { state, commit } = useStore();
  const isModal = computed(() => state.isModal);

  function Close_Modal () {
    commit('SET_MODAL', false);
  }

  onUpdated(function () {
    document.body.style.position = isModal.value ? 'fixed' : 'relative';
    document.body.style.overflow = isModal.value ? 'hidden' : 'scroll';
  });
</script>

<style lang="scss">
  .base-modal {
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(15px);
    @media only screen and (min-width: 0) {
      > div {
        width: 100%;
        max-width: 500px;
        margin: 24px;
        padding: 24px;
        background-color: white;
        border-radius: 4px;
        .close-icon {
          top: -19px;
          right: -19px;
        }
      }
    }

    @media only screen and (max-width: 600px) {
      > div {
        height: 100%;
        overflow: scroll;
      }
    }
  }
</style>
